import React, { useEffect, useRef, useState } from "react";
import { LoadingState, LoadingStateOps } from "../../data-layer/loading-state";
import { AuthClient, UserAuthToken } from "./auth-client";
import { useStore } from "../../../store/hooks/use-store";
import { ModalLoadingSpinner } from "../../../routes/modal-loading-spinner";
import { AppView } from "../../../styles/AppView";
import { Navigate } from "react-router";

export const AuthLoginHandler = () => {
  const [tokenLS, setTokenLS] = useState<LoadingState<{ token: UserAuthToken; state: string }>>(
    LoadingStateOps.loadingS,
  );

  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get("code");
  const state = searchParams.get("state");

  const { state: storeState, dispatch } = useStore();

  const anonymousAccessToken = storeState.auth?.authToken?.access_token;

  useEffect(() => {
    if (code && state && anonymousAccessToken) {
      void AuthClient.login({ code, state }, anonymousAccessToken).then(userAuthToken => {
        if (userAuthToken) {
          setTokenLS(LoadingStateOps.asLoaded({ token: userAuthToken, state }));
          dispatch({ type: "user-logged-in", value: userAuthToken });

          return;
        } else {
          setTokenLS(LoadingStateOps.asFailed("auth_service_not_responded"));
        }
      });
    }
  }, [anonymousAccessToken]);

  if (tokenLS.__tag === "loading") {
    return (
      <AppView>
        <ModalLoadingSpinner />
      </AppView>
    );
  } else if (tokenLS.__tag === "loaded") {
    return <Navigate to={tokenLS.data.state} />;
  } else {
    return <Navigate to={"/"} />;
  }
};
